import React from 'react'
import styled from 'styled-components'

import {Stack} from '@/components/stack'
import {Text} from '@/components/text'
import {inputStyles, Label} from '@/styles/inputs'

interface Props
    extends Omit<JSX.IntrinsicElements['textarea'], 'ref' | 'onChange' | 'type' | 'css'> {
    label?: string
    className?: string
    onChange?: (value: string) => void
    error?: string | null
}

const Textarea = ({label, placeholder, onChange, error, required, className, ...props}: Props) => {
    const id = React.useId()

    return (
        <Stack $space={8} $stretch className={className}>
            {label && (
                <Label htmlFor={id} $required={required}>
                    {label}
                </Label>
            )}

            <StyledTextarea
                id={id}
                placeholder={placeholder}
                onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                    onChange?.(e.target.value)
                }}
                $hasError={!!error}
                rows={3}
                required={required}
                {...props}
            />

            {error && (
                <Text $variant="label-base" $color="error">
                    {error}
                </Text>
            )}
        </Stack>
    )
}

const StyledTextarea = styled.textarea<{$hasError: boolean}>`
    ${(props) => inputStyles({$hasError: props.$hasError})};

    overflow-x: hidden;
    resize: none;
`

export default Textarea
